import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=94fc126e&"
import script from "./DesktopHeader.vue?vue&type=script&lang=js&"
export * from "./DesktopHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports